
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Andheritopunecab() {



    const cardData =
    {
        keyword: 'Andheri to Pune Cab',
        heading: 'Meghana Cab : Andheri to Pune Cab',
        headingDescription: 'Meghana Cab offers Andheri to Pune Cab services, ensuring a smooth, safe, and comfortable ride between Mumbai’s bustling suburb and the vibrant city of Pune. Whether you are traveling for business, education, a family visit, or a weekend getaway, our clean and well-serviced cabs are driven by professional chauffeurs who prioritize your safety and punctuality. Select from a range of vehicle options—hatchbacks, sedans, SUVs, and tempo travellers—to match your travel needs. Benefit from transparent pricing, door-to-door pickup, and 24/7 customer support. Book your Andheri to Pune Cab with Meghana Cab and enjoy a stress-free intercity journey tailored to your comfort.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 as the seat of the Peshwas of the Maratha Empire, this grand fortification features massive teak doors, strong granite ramparts, ornate gardens, and historic ruins. Though largely destroyed by fire in 1828, its five gateways—including the north‑facing Delhi Darwaza—and remaining bastions offer a poignant glimpse into Maratha royal ambition and architectural finesse." 
  },
  {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892 by Sultan Aga Khan III to provide famine relief, this elegant Italian‑arched palace later became the site of Mahatma Gandhi’s imprisonment. Surrounded by expansive lawns, the palace now houses a Gandhi museum and memorials to Kasturba and Mahadev Desai, preserving the legacy of India’s freedom struggle." 
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched about 1,312 m above sea level on the Sahyadri range, this hill‑top fortress was the scene of the legendary 1670 Battle of Sinhagad. It boasts steep slopes, two main gates (Pune and Kalyan Darwaza), the memorial to warrior Tanaji Malusare, and offers sweeping views and popular local cafés at dawn." 
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in Koregaon Park, this serene meditation centre was founded on Osho’s teachings. It features lush gardens, modern meditation halls, and a range of wellness workshops, attracting seekers from across the globe seeking peace and self‑discovery." 
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "An 8th‑century rock‑cut temple carved out of a single basalt block, this underground temple honors Lord Shiva and includes a majestic Nandi shrine within a circular mandapa supported by pillars—an ancient gem offering spiritual calm amidst the city." 
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "One of Pune’s most revered Ganesha shrines, known for its beautifully adorned gold idol. The temple buzzes during festivals, drawing thousands of pilgrims and visitors seeking blessings and experiencing vibrant Marathi devotion." 
  },
  {
    "title": "Parvati Hill & Temple",
    "description": "Rising to 2,100 ft, Parvati Hill is the city’s second‑highest point and hosts the historic Peshwa‑era Parvati Temple atop its summit. The climb (108 steps) rewards visitors with panoramic views of Pune’s sprawl and the surrounding Western Ghats." 
  },
  {
    "title": "Lal Mahal",
    "description": "This ‘Red Palace’—originally built by Shivaji’s father—played a key role in Maratha history. Though largely reconstructed, its red‑plastered walls stand as a landmark in Old Pune and a reminder of the era’s parentage and heritage." 
  },
  {
    "title": "Shinde Chhatri",
    "description": "A memorial shrine dedicated to Maratha commander‑in‑chief Mahadji Shinde (Scindia), this elegant domed pavilion built in 1794 showcases exquisite carvings and Rajasthani‑style architectural influences—a peaceful heritage spot near Wanwadi." 
  },
  {
    "title": "Rajiv Gandhi Zoological Park",
    "description": "Also known as Katraj Zoo & Snake Park, this well‑maintained park on the city’s outskirts is home to diverse wildlife, reptiles, aviaries, botanical collections, and an urbane, family‑friendly educational experience." 
  }
],

"services": [
  {
    "name": "One Way Cab Andheri to Pune",
    "description": "Book a convenient one-way cab from Andheri to Pune for quick, hassle-free travel. Our reliable service guarantees punctual pickups, clean vehicles, and professional drivers to make your journey smooth and comfortable."
  },
  {
    "name": "Round Trip Taxi Andheri to Pune",
    "description": "Plan your round trip between Andheri and Pune with our flexible taxi service. Whether for business or leisure, enjoy well-maintained cars, courteous drivers, and affordable packages tailored to your schedule."
  },
  {
    "name": "Online Booking Cab Andheri to Pune",
    "description": "Experience seamless cab booking from Andheri to Pune with our easy-to-use online platform. Choose your vehicle, schedule your ride, and get instant confirmation—all at your fingertips for a stress-free travel plan."
  },
  {
    "name": "AC Car Hire from Andheri to Pune",
    "description": "Travel comfortably in our air-conditioned cars from Andheri to Pune, perfect for beating the Mumbai heat. Our AC car hire offers a relaxing environment, ensuring you arrive refreshed and ready for your day."
  },
  {
    "name": "Affordable Taxi Andheri to Pune",
    "description": "Get the best value for your money with our affordable taxi services from Andheri to Pune. We combine budget-friendly pricing with high safety standards and clean vehicles, making quality travel accessible to everyone."
  },
  {
    "name": "Sedan & SUV Cabs Andheri to Pune",
    "description": "Choose between stylish sedans and spacious SUVs for your trip from Andheri to Pune. Whether traveling solo, with family, or a group, our diverse fleet meets your comfort and space requirements."
  },
  {
    "name": "Andheri East to Pune Cab",
    "description": "Reliable cab service specifically from Andheri East to Pune, ensuring timely pickups and smooth rides. Our drivers are familiar with the best routes to avoid traffic and get you there efficiently."
  },
  {
    "name": "Andheri West to Pune Travel by Taxi",
    "description": "Enjoy comfortable and safe taxi rides from Andheri West to Pune. Our service is designed for convenience, with professional drivers who prioritize your safety and timely arrival."
  },
  {
    "name": "Mumbai Andheri to Pune Chauffeur Cabs",
    "description": "Travel in style with our chauffeur-driven cabs from Mumbai Andheri to Pune. Experience luxury, professionalism, and personalized service for business or leisure trips."
  },
  {
    "name": "Family Trip Cab Andheri to Pune",
    "description": "Make your family trips comfortable and memorable with our spacious and safe cabs from Andheri to Pune. We offer flexible itineraries, ensuring everyone enjoys the journey as much as the destination."
  },
  {
    "name": "24/7 Taxi Booking Andheri to Pune",
    "description": "Our taxi booking service from Andheri to Pune is available 24/7, so you can plan your trips anytime. Immediate confirmations, quick pickups, and reliable service, no matter the hour."
  },
  {
    "name": "Business Travel Taxi Andheri to Pune",
    "description": "Specialized taxi services designed for business travelers from Andheri to Pune. Enjoy punctual pickups, executive cars, and a professional experience that keeps your schedule on track."
  },
  {
    "name": "Private Car Rental Andheri to Pune",
    "description": "Hire a private car from Andheri to Pune for personalized, hassle-free travel. Ideal for travelers who value privacy, comfort, and flexibility with their itinerary."
  },
  {
    "name": "Reliable Andheri to Pune Taxi Service",
    "description": "Count on our reliable taxi service from Andheri to Pune to get you there safely and on time. Our fleet is regularly maintained, and drivers are experienced, ensuring a worry-free journey."
  },
  {
    "name": "Express Highway Cab Andheri to Pune",
    "description": "Take advantage of the express highway route with our fast and efficient cab service from Andheri to Pune. Save time with skilled drivers who navigate the quickest routes while ensuring passenger comfort."
  }
],
"tableData": [
  ["One Way Cab Andheri to Pune", "Round Trip Taxi Andheri to Pune"],
  ["Online Booking Cab Andheri to Pune", "AC Car Hire from Andheri to Pune"],
  ["Affordable Taxi Andheri to Pune", "Sedan & SUV Cabs Andheri to Pune"],
  ["Andheri East to Pune Cab", "Andheri West to Pune Travel by Taxi"],
  ["Mumbai Andheri to Pune Chauffeur Cabs", "Family Trip Cab Andheri to Pune"],
  ["24/7 Taxi Booking Andheri to Pune", "Business Travel Taxi Andheri to Pune"],
  ["Private Car Rental Andheri to Pune", "Reliable Andheri to Pune Taxi Service"],
  ["Express Highway Cab Andheri to Pune", ""]
],








"whychoose": [
    {
        "WhyChooseheading": "Reliable Andheri to Pune Cab Service",
        "WhyChoosedescription": "Meghana Cab offers dependable cab services from Andheri to Pune, ensuring a comfortable and hassle-free journey. Our experienced drivers and well-maintained vehicles make your long-distance travel smooth and enjoyable."
    },
    {
        "WhyChooseheading": "Flexible Andheri to Pune Travel Packages",
        "WhyChoosedescription": "Choose from one-way, round-trip, or customized cab packages that suit your travel needs. Whether it’s for business, leisure, or family visits, we handle the logistics to provide a seamless experience."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Our fares for Andheri to Pune cab rides include fuel, tolls, taxes, and driver allowances. We offer upfront pricing so you know exactly what you’re paying for, with options across different vehicle types."
    },
    {
        "WhyChooseheading": "Comfortable and Clean Vehicles for Long Journeys",
        "WhyChoosedescription": "Travel in sanitized, air-conditioned sedans, SUVs, or tempo travellers based on your group size. Our vehicles are regularly serviced to ensure maximum comfort throughout your journey."
    },
    {
        "WhyChooseheading": "Experienced Drivers Familiar with Mumbai-Pune Route",
        "WhyChoosedescription": "Our drivers are skilled and knowledgeable about the fastest and safest routes from Andheri to Pune. They ensure timely pickups and drop-offs while prioritizing your safety."
    },
    {
        "WhyChooseheading": "Customizable Trip Options and Scheduling",
        "WhyChoosedescription": "Whether you need a quick one-way transfer or a multi-day cab for your Pune visit, we offer flexible scheduling. Add stops or overnight stays to personalize your travel itinerary."
    },
    {
        "WhyChooseheading": "24/7 Booking and Dedicated Customer Support",
        "WhyChoosedescription": "Book your cab any time of day or night with our 24/7 customer support. We’re available to assist you before and during your journey, ensuring a worry-free travel experience."
    },
    {
        "WhyChooseheading": "Ideal for Families, Corporate Travelers, and Groups",
        "WhyChoosedescription": "Our Andheri to Pune cab service caters to diverse travelers including families, business professionals, and group tours. We prioritize comfort, punctuality, and a smooth ride for all our passengers."
    }
]























    }

const faqData = [
    {
        question: "How can I book a cab from Andheri to Pune with Meghana Cab?",
        answer: "You can book your Andheri to Pune cab by calling Meghana Cab at +91 9075462128 or through our website for quick and convenient booking."
    },
    {
        question: "What vehicle options are available for the Andheri to Pune route?",
        answer: "We provide a variety of vehicles including sedans, SUVs, and tempo travellers to suit solo travelers, families, or groups."
    },
    {
        question: "Are Meghana Cab drivers familiar with the Andheri to Pune route?",
        answer: "Yes, our drivers are experienced and knowledgeable about the best routes between Andheri and Pune to ensure a smooth journey."
    },
    {
        question: "Is one-way cab service available from Andheri to Pune?",
        answer: "Yes, Meghana Cab offers both one-way and round-trip services to accommodate your travel needs."
    },
    {
        question: "Does the fare include tolls, fuel, and driver charges?",
        answer: "Our fare includes fuel, tolls, and driver charges. Additional fees may apply for parking or extended waiting times."
    },
    {
        question: "Are the vehicles sanitized before the trip?",
        answer: "Yes, all our vehicles are thoroughly sanitized before each trip to ensure your safety and comfort."
    },
    {
        question: "Is the Andheri to Pune cab service available 24/7?",
        answer: "Yes, we provide 24/7 cab service from Andheri to Pune to fit your schedule."
    },
    {
        question: "Can I request stops for meals or sightseeing on the way?",
        answer: "Yes, stops can be arranged on request. Please inform us during booking to plan accordingly."
    },
    {
        question: "What payment methods do you accept?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
    {
        question: "How can I contact Meghana Cab to book an Andheri to Pune cab?",
        answer: "Call us at +91 9075462128 anytime to book your cab or get travel assistance."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Ajay Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The ride from Andheri to Pune with Meghana Cab was comfortable and punctual. The driver was very professional.”',
    },
    {
        name: 'Ms. Priya Shah',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Excellent service! Meghana Cab made our trip from Andheri to Pune smooth and hassle-free.”',
    },
];








































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];






const andheriToPuneCabSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Andheri to Pune Cab Service",
  "image": "https://www.meghanacabs.com/assets/images/andheri-to-pune-cab.jpg",
  "description": "Book affordable and reliable taxi service from Andheri to Pune with Meghana Cabs. One way and round trip cabs available for business, family, and airport transfers.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": [
    "One Way Cab Andheri to Pune",
    "Round Trip Taxi Andheri to Pune",
    "AC Car Hire from Andheri to Pune",
    "Sedan & SUV Cabs Andheri to Pune",
    "Family Trip Cab Andheri to Pune",
    "Business Travel Taxi Andheri to Pune",
    "Private Car Rental Andheri to Pune"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Andheri"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Andheri to Pune Taxi Offers",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "One Way Cab Andheri to Pune"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Round Trip Taxi Andheri to Pune"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "AC Car Hire from Andheri to Pune"
        }
      }
    ]
  }
};






    return (
        <div>
<Helmet>
  <title>Andheri to Pune Cab | Reliable Taxi Service | Meghana Cabs</title>
  <meta
    name="description"
    content="Book affordable and reliable taxi service from Andheri to Pune with Meghana Cabs. One way and round trip cabs available for business, family, and airport transfers."
  />
  <meta
    name="keywords"
    content="One Way Cab Andheri to Pune, Round Trip Taxi Andheri to Pune, Online Booking Cab Andheri to Pune, AC Car Hire from Andheri to Pune, Affordable Taxi Andheri to Pune, Sedan & SUV Cabs Andheri to Pune, Andheri East to Pune Cab, Andheri West to Pune Travel by Taxi, Mumbai Andheri to Pune Chauffeur Cabs, Family Trip Cab Andheri to Pune, 24/7 Taxi Booking Andheri to Pune, Business Travel Taxi Andheri to Pune, Private Car Rental Andheri to Pune, Reliable Andheri to Pune Taxi Service, Express Highway Cab Andheri to Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(andheriToPuneCabSchema)}
  </script>
</Helmet>




            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/45.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Andheritopunecab;